<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="WMS产线入库监测 center_11"> </chart-title>
    <el-row class="two_col">
      <el-col :span="10"> <div id="center_11" /></el-col>
      <el-col :span="14"
        ><div id="chart-table">
          <div class="table-title-item">
            <subtitle-1
              :iconLeft="'biaoti2'"
              :title="'WMS产品齐包监控'"
              class="table-title"
            ></subtitle-1>
            <el-button
              type="primary"
              slot="detail"
              size="mini"
              style="margin-right: 20px"
              >详 情</el-button
            >
          </div>
          <dv-scroll-board
            :config="config"
            style="width: 100%; height: 30%; margin-top: 10px"
          />
          <div class="table-title-item">
            <subtitle-1
              :iconLeft="'biaoti2'"
              :title="'WMS产品齐套入库监测'"
              class="table-title"
            ></subtitle-1>
            <el-button
              type="primary"
              slot="detail"
              size="mini"
              style="margin-right: 20px"
              >详 情</el-button
            >
          </div>
          <dv-scroll-board
            :config="config"
            style="width: 100%; height: 30%; margin-top: 10px"
          /></div
      ></el-col>
    </el-row>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import Subtitle1 from "../../../components/subtitle-1";
export default {
  mixins: [resize],
  name: "center_11",
  components: { ChartTitle, Subtitle1 },
  data() {
    return {
      chart: null,
      config: {
        rowNum: 4,
        headerBGC: "transparent", // 表头背景色
        oddRowBGC: "transparent", // 奇数行背景色
        evenRowBGC: "transparent", // 偶数行背景色
        waitTime: 2000, // 轮播时间间隔(ms)
        // align: [
        //   "center",
        //   "center",
        //   "center",
        //   "center",
        //   "center",
        //   "center",
        //   "center",
        // ],
        columnWidth: ["", "", "", "", "", 50],
        data: [
          [
            `<span style="color:#409EFF">当前状态`,
            `<span style="color:#409EFF">202212160001`,
            `<span style="color:#409EFF">商家名`,
            `<span style="color:#409EFF">客户名`,
            `<span style="color:#409EFF">2022-12-14`,
          ],
          [
            `<span style="color:#409EFF">当前状态`,
            `<span style="color:#409EFF">202212160001`,
            `<span style="color:#409EFF">商家名`,
            `<span style="color:#409EFF">客户名`,
            `<span style="color:#409EFF">2022-12-14`,
          ],
          [
            `<span style="color:#409EFF">当前状态`,
            `<span style="color:#409EFF">202212160001`,
            `<span style="color:#409EFF">商家名`,
            `<span style="color:#409EFF">客户名`,
            `<span style="color:#409EFF">2022-12-14`,
          ],
          [
            `<span style="color:#409EFF">当前状态`,
            `<span style="color:#409EFF">202212160001`,
            `<span style="color:#409EFF">商家名`,
            `<span style="color:#409EFF">客户名`,
            `<span style="color:#409EFF">2022-12-14`,
          ],
          [
            `<span style="color:#409EFF">当前状态`,
            `<span style="color:#409EFF">202212160001`,
            `<span style="color:#409EFF">商家名`,
            `<span style="color:#409EFF">客户名`,
            `<span style="color:#409EFF">2022-12-14`,
          ],
        ],
      },
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("center_11"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        color: ["#009dff", "#22e4ff", "#3bffd0"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom: "15%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["25%", "45%"],
            center: ["50%", "40%"],
            data: [
              { value: 1048, name: "计划入库" },
              { value: 735, name: "实际入库" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{@2012}",
              color: "#C0C4CC",
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 40vh;
  .two_col {
    padding: 0 10px;
    height: calc(100% - 30px);
  }
  #center_11 {
    height: 100%;
  }
  #chart-table {
    background: transparent;
    height: 100%;

    .table-title {
      margin: 20px 0px 0px 5px;
    }
    .table-title-item {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }
  }
}
</style>
<style lang="scss">
// .table-title {
//   svg {
//     width: 18px;
//     height: 18px;
//   }
// }
</style>
